export const PROJECT_NAME = 'countryside-card-frontend';
export const PAGE_TYPE = PROJECT_NAME;
export const SITE_TYPE = PROJECT_NAME;

export type TVillageOffersType = 'builder' | 'resaleAndBuilder' | 'resale';

export const PRICE_DISCLAIMER_TEXT_MAP: { [key: string]: string } = {
  builder: 'Условия покупки указаны для первичной недвижимости напрямую от застройщиков',
  resaleAndBuilder: 'Условия покупки указаны для недвижимости от застройщика', // tslint:disable-line: max-line-length
  resale: 'Условия покупки указаны для вторичной недвижимости от агентов и собственников',
};

export const CONTENT_MAX_WIDTH = 1280;

export const CADASTRE_SERVICE_LINK = 'https://egrp365.ru/map/';
